<template>
  <div class="">
    <v-card flat>
      <v-container>
        <v-layout
          row
          wrap
          v-if="singleBooking.booking_payment_status !== 'Paid'"
        >
          <v-flex lg6 md6 sm12 xs12>
            <v-container fluid>
              <v-autocomplete
                label="Mode of "
                :items="bookingPaymentMethods"
                :rules="[(v) => !!v || 'Mode of payment is required']"
                required
                @change="selectedPayment"
                :return-object="true"
                item-text="payment_method_name"
                :loading="$loadingTrue"
              ></v-autocomplete>
            </v-container>
          </v-flex>
          <!--Card payment-->
          <v-flex
            lg4
            md4
            sm12
            xs12
            v-if="payment.mode !== 6 && show_payment_gateway === true"
          >
            <v-container fluid>
              <v-autocomplete
                label="Payment Account Used"
                :items="bookingPaymentGateways_"
                :rules="[(v) => !!v || 'Payment Gateway is required']"
                required
                v-model="payment.payment_gateway"
                @change="selectedPaymentGateway"
                :return-object="true"
                item-text="payment_gateway_name"
                item-value="payment_gateway_public_id"
                :loading="$loadingTrue"
              ></v-autocomplete>
            </v-container>
          </v-flex>
          <v-flex lg4 md4 sm12 xs12>
            <v-container>
              <v-autocomplete
                label="Currency to Be Paid In"
                :items="allCurrencies"
                :rules="[(v) => !!v || 'Currency  is required']"
                required
                v-model="payment.currency_id"
                :return-object="true"
                item-text="currency_name"
                item-value="currency_public_id"
                :loading="$loadingTrue"
                @change="selectedPaymentCurrency"
              ></v-autocomplete>
            </v-container>
          </v-flex>
          <v-flex lg4 md6 sm12 xs12>
            <v-container>
              <v-text-field
                label="Payment"
                v-model="payment.payment_amount"
                :rules="requiredRules"
                required
                type="number"
                :max="singleBooking.booking_payment_balance"
              ></v-text-field>
            <div style="font-size: 20px; font-weight: bold;">
  <strong>
    Original Balance: {{ singleBooking.currency }}
    {{ $roundOff(singleBooking.booking_payment_balance) }}
  </strong>
</div>

<div style="font-size: 30px; font-weight: bold;">
  <strong>
    {{ this.balance_currency }}
    {{
      $roundOff(
        convertBasedBookingCreationDate(
          singleBooking.currency,
          singleBooking.booking_payment_balance,
          singleBooking.currency_buying_rate_at_time,
          singleBooking.currency_selling_rate_at_time
        ).amount
      ).toLocaleString("en")
    }}
  </strong>
</div>
            </v-container>
          </v-flex>
          <!--Card payment-->
          <v-flex lg6 md6 sm12 xs12 v-if="payment.mode === 5">
            <v-container>
              <v-text-field
                label="Card first 4"
                v-model="payment.first_four"
                :rules="requiredRules"
                required
              ></v-text-field>
            </v-container>
          </v-flex>
          <v-flex lg6 md6 sm12 xs12 v-if="payment.mode === 5">
            <v-container>
              <v-text-field
                label="Last 4 digits"
                v-model="payment.last_four"
                :rules="requiredRules"
                required
              ></v-text-field>
            </v-container>
          </v-flex>
          <!--Mpesa-->
          <v-flex lg6 md6 sm12 xs12 v-if="payment.mode === 6">
            <v-container>
              <v-text-field
                label="Payer's Phone"
                v-model="payment.phone"
                :rules="requiredRules"
                required
              ></v-text-field>
              <small>Safaricom Number</small>
            </v-container>
          </v-flex>
          <v-flex lg6 md6 sm12 xs12 v-if="payment.mode === 6">
            <v-container>
              <v-btn
                :depressed="true"
                @click.prevent="requestMpesaPayment()"
                block
                >Request Payment</v-btn
              >
            </v-container>
          </v-flex>
          <v-flex
            lg6
            md6
            sm12
            xs12
            v-if="payment_requested === true"
          >
            <v-container>
              <v-btn
                :depressed="true"
                color="warning"
                block
                @click="checkPayment()"
                :loading="$loadingTrue"
                >Confirm Payment</v-btn
              >
            </v-container>
                        </v-flex>
          <!--Other Payment-->
          <v-flex
            lg12
            md12
            sm12
            xs12
            v-if="
              payment.mode === 2 || payment.mode === 0 || payment.mode === 8
            "
          >
            <v-container>
              <v-text-field
                label="Reference Number/Transacted By"
                v-model="payment.mpesa_ref"
                :rules="requiredRules"
                required
              ></v-text-field>
            </v-container>
          </v-flex>
          <v-flex lg12 md12 sm12 xs12 v-if="payment.mode === 5">
            <v-container>
              <v-text-field
                label="Name"
                v-model="payment.name"
                :rules="requiredRules"
                required
              ></v-text-field>
            </v-container>
          </v-flex>
          <v-flex
            lg12
            md12
            sm12
            xs12
            v-if="payment.mode === 4 || payment.mode === 3"
          >
            <v-container>
              <v-text-field
                label="Reference"
                v-model="payment.mpesa_ref"
                :rules="requiredRules"
                required
              ></v-text-field>
            </v-container>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex lg6 md6 xs12>
            <v-btn
              :depressed="true"
              color="primary"
              @click.prevent="submitPayment()"
              >Submit Payment</v-btn
            >
            <v-btn
              :depressed="true"
              color="info"
              @click.prevent="bank_slip_modal = true"
              >Add Bank Slip</v-btn
            >
            <v-btn
										:depressed="true"
										color="warning"
										@click="openJavaApplication()"
										v-if="singleBooking.status !== 'Cancelled'"
										:loading="$loadingTrue"
										>Print Receipt</v-btn
									>

            <v-dialog v-model="bank_slip_modal" persistent max-width="1000px">
              <v-card>
                <v-card-text>
                  <v-layout row wrap>
                    <v-flex lg4 md4 sm12 xs12>
                      <v-container>
                        <v-text-field
                          v-model="bank_slip_details.first_name"
                          label="First Name"
                          required="required"
                          :rules="requiredRules"
                          type="text"
                        ></v-text-field>
                      </v-container>
                    </v-flex>
                    <v-flex lg4 md4 sm12 xs12>
                      <v-container>
                        <v-text-field
                          v-model="bank_slip_details.last_name"
                          label="Last Name"
                          required
                          :rules="requiredRules"
                        ></v-text-field>
                      </v-container>
                    </v-flex>
                    <v-flex lg4 md4 sm12 xs12>
                      <v-container>
                        <v-text-field
                          v-model="bank_slip_details.slip_reference"
                          label="Slip reference"
                          required
                          :rules="requiredRules"
                        ></v-text-field>
                      </v-container>
                    </v-flex>
                    <v-flex lg4 md4 sm12 xs12>
                      <v-container>
                        <v-autocomplete
                          label="Currency Paid In"
                          :items="allCurrencies"
                          :rules="[(v) => !!v || 'Currency  is required']"
                          required
                          v-model="bank_slip_details.currency_id"
                          item-text="currency_name"
                          item-value="currency_public_id"
                          :loading="$loadingTrue"
                        ></v-autocomplete>
                      </v-container>
                    </v-flex>

                    <v-flex lg4 md6 sm12 xs12>
                      <v-container>
                        <v-text-field
                          label="Payment"
                          v-model="bank_slip_details.payment_amount"
                          :rules="requiredRules"
                          required
                          type="number"
                        ></v-text-field>
                      </v-container>
                    </v-flex>
                    <v-flex lg4 md6 sm12 xs12>
                      <v-container>
                        <v-btn
                          :depressed="true"
                          color="primary"
                          @click="addSlipDetails()"
                          >Submit Details</v-btn
                        >
                        <v-btn
                          color="red darken-1"
                          flat
                          @click="bank_slip_modal = false"
                          >Close</v-btn
                        >
                      </v-container>
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-card-actions> </v-card-actions>
              </v-card>
            </v-dialog>
          </v-flex>
        </v-layout>
        <v-layout v-if="singleBooking.booking_payment_status === 'Paid'">
          <h4 v-if="singleBooking.booking_payment_status === 'Paid'">
            This Booking has been paid for.
          </h4>
          <v-btn
            :depressed="true"
            v-if="singleBooking.booking_payment_status === 'Paid'"
            @click="openCheckIn()"
            class="btn pantone"
            >Check In</v-btn
          >
        </v-layout>
        {{ amount }}
      </v-container>
    </v-card>
    <br />
    <h4 class="earth-color">CURRENT BOOKING PAYMENTS</h4>
    <br />
    <v-data-table
      :headers="columns"
      :items="singleBooking.booking_payments"
      :search="search"
      :disable-initial-sort="true"
      :loading="$loadingTrue"
    >
      <v-progress-linear
        slot="progress"
        color="primary"
        indeterminate
      ></v-progress-linear>
      <template slot="items" slot-scope="props">
        <td class="fancy">
          {{ formated_date_time(props.item.transaction_date) }}
        </td>
        <td class="fancy">{{ props.item.payment_method }}</td>
        <td class="fancy">
          {{ props.item.transaction_payment_currency }}
          {{ $roundOff(props.item.transaction_total) }}
        </td>
        <td class="fancy">
          {{ props.item.transaction_total_currency }}
          {{ $roundOff(props.item.transaction_balance) }}
        </td>
        <td class="fancy">
          {{ props.item.transaction_total_currency }}
          {{ $roundOff(props.item.transaction_original_cost) }}
        </td>
      </template>
      <v-alert slot="no-results" :value="true" color="error" icon="warning">
        Your search for "{{ search }}" found no results.
      </v-alert>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: "gate-payment",
  data() {
    return {
      search: "",
      showBalance: false,
      bank_slip_modal: false,
      balance_currency: "KES",
      show_payment_gateway: false,
      columns: [
        {
          text: "Registered on",
          value: "transaction_date",
        },
        {
          text: "Payment Type",
          value: "payment_method",
        },
        {
          text: "Amount Paid",
          value: "transaction_total",
        },
        {
          text: "Balance",
          value: "transaction_balance",
        },
        {
          text: "Original Balance",
          value: "transaction_original_cost",
        },
      ],
      requiredRules: [(v) => !!v || "This field is required"],
      payment: {
        booking_id: this.$route.params.booking_id,
        booking_amount: "",
        currency_id: "",
        payment_amount: "",
        mode: "",
        mpesa_ref: "",
        payment_gateway: "",
        phone: "254",
        last_four: "",
        first_four: "",
        session_id: localStorage.getItem("lkjhgfdsa"),
      },
      bank_slip_details: {
        first_name: "",
        last_name: "",
        slip_reference: "",
        currency_id: "",
        payment_amount: "",
      },
      payment_requested: false,
    };
  },
  beforeCreate() {
    this.$store.dispatch("get_all_credit_card_accounts");
  },
  created() {
    this.$store.dispatch("get_booking", this.$route.params.booking_id);
    this.$store.dispatch("get_all_credit_card_accounts");
    this.$store.dispatch("get_all_payment_methods");
    
  },
  computed: {
    amount() {
      if (this.singleBooking.booking_payment_balance === 0) {
        this.openCheckIn();
      }
      return null;
      // var amount = this.singleBooking.total_cost
      // var balance = Number(amount) - Number(this.payment.payment_amount)
      // return balance
    },
  },
  methods: {
    checkPayment() {
      this.$store.dispatch("loading_true");
      this.$store.dispatch("get_booking", this.$route.params.booking_id);
      this.payment_mode = "Mpesa";
    },
    openCheckIn: function () {
      this.$router.push({
        name: "Checkin",
        params: {
          booking_id: this.$route.params.booking_id,
        },
      });
    },
    selectedPayment: function (data) {
      if (data.payment_gateways_set === true) {
        this.show_payment_gateway = true;
      } else {
        this.show_payment_gateway = false;
      }

      this.payment.mode = this.bookingPaymentMethods.indexOf(data);
      this.payment.payment_method = data.payment_method_public_id;
    },
    selectedPaymentGateway: function (data) {
      this.payment.currency_id = data.payment_gateway_currency;
    },
    selectedPaymentCurrency() {
      this.balance_currency = this.payment.currency_id.currency_name;
      this.payment.currency_id = this.payment.currency_id.currency_public_id;
    },
    submitPayment: function () {
      this.payment.booking_amount = this.singleBooking.total_cost;
      this.$store.dispatch("post_payment", this.payment);
      this.payment = {
        payment_method: "",
        booking_id: this.$route.params.booking_id,
        booking_amount: "",
        payment_amount: "",
        mode: "",
        mpesa_ref: "",
        phone: "254",
        last_four: "",
        first_four: "",
        session_id: localStorage.getItem("lkjhgfdsa"),
      };
    },
    requestMpesaPayment: function () {
      this.payment_requested = true;
      var data = {
        phone: this.payment.phone,
        payment_amount: this.payment.payment_amount,
        booking_id: this.$route.params.booking_id,
        session_id: localStorage.getItem("lkjhgfdsa"),
      };
      this.$store.dispatch("booking_mpesa_request", data);
    },
    addSlipDetails: function () {
      this.bank_slip_modal = false;
      var data = {
        first_name: this.bank_slip_details.first_name,
        last_name: this.bank_slip_details.last_name,
        slip_reference: this.bank_slip_details.slip_reference,
        booking_id: this.$route.params.booking_id,
        payment_amount: this.bank_slip_details.payment_amount,
        currency_id: this.bank_slip_details.currency_id,
        session_id: localStorage.getItem("lkjhgfdsa"),
      };
      this.$store.dispatch("booking_bank_slip_request", data);
    },
    openJavaApplication() {
	  // alert("Copied the Booking Ref Code")
	  this.$store.state.LoadingStore.loading = true;
	  var data = {
		booking_id: this.$route.params.booking_id,
		currency_id: this.currency_id,
		session_id: localStorage.getItem("lkjhgfdsa"),
	  };
	  this.$store.dispatch("request_receipt", data);
	},
  },
};
</script>

<style>
</style>
